import { EnumValue } from "./enum-value";

export const MesValues: EnumValue[] = [
    {
        codigo: '01',
        descricao: 'Janeiro'
    },
    {
        codigo: '02',
        descricao: 'Fevereiro'
    },
    {
        codigo: '03',
        descricao: 'Março'
    },
    {
        codigo: '04',
        descricao: 'Abril'
    },
    {
        codigo: '05',
        descricao: 'Maio'
    },
    {
        codigo: '06',
        descricao: 'Junho'
    },
    {
        codigo: '07',
        descricao: 'Julho'
    },
    {
        codigo: '08',
        descricao: 'Agosto'
    },
    {
        codigo: '09',
        descricao: 'Setembro'
    },
    {
        codigo: '10',
        descricao: 'Outubro'
    },
    {
        codigo: '11',
        descricao: 'Novembro'
    },
    {
        codigo: '12',
        descricao: 'Dezembro'
    },
]

export const getMesLabel = (codigo: string|number): string => {
    const match = MesValues.find(
      value => Number(value.codigo) === Number(codigo)
    );
    return match ? match.descricao : '';
  };

